import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as model from "../../../models";
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
	selector: 'shopping-cart-event-list',
	template: `
		<shopping-cart-event-list-presentation
		[displayEventsWithTicketControls]="displayEventsWithTicketControls"
		[editable]="editable"
		(removeTickets)="processRemoveTickets($event)"
		(eventTitleClicked)="navigateToEventSale($event)"></shopping-cart-event-list-presentation>
	`,
})
export class ShoppingCartEventListComponent {

	displayEventsWithTicketControls: DisplayEventWithTicketControls[] = [];

	@Output() removeTickets = new EventEmitter<string[]>();

	@Input() editable: boolean
	@Input() set displayShoppingCart(displayShoppingCart: model.DisplayShoppingCart) {
		if (displayShoppingCart && displayShoppingCart.events) {
			this.displayEventsWithTicketControls = []
			this._displayShoppingCart = displayShoppingCart
			displayShoppingCart.events.forEach(displayEvent => {
				let displayEventWithTicketControls: DisplayEventWithTicketControls = {
					eventId: displayEvent.eventId,
					event: displayEvent.event,
					eventBegin: displayEvent.eventBegin,
					eventEnd: displayEvent.eventEnd,
					venue: displayEvent.venue,
					locationCity: displayEvent.locationCity,
					locationPostalCode: displayEvent.locationPostalCode,
					visualTickets: false,
					visualBulkTickets: false,
					displayTicketsWithControls: []
				}
				displayEvent.displayTickets.forEach(displayTicket => {
					displayEventWithTicketControls.visualTickets = displayTicket.isVisualTicket ? true : displayEventWithTicketControls.visualTickets
					displayEventWithTicketControls.visualBulkTickets = displayTicket.isVisualBulkTicket ? true : displayEventWithTicketControls.visualBulkTickets
					displayEventWithTicketControls.displayTicketsWithControls.push({
						displayTicket: displayTicket,
						control: new FormControl(displayTicket.numberOfSeats)
					})
				})
				this.displayEventsWithTicketControls.push(displayEventWithTicketControls)
			})
		}
	}

	private _displayShoppingCart: model.DisplayShoppingCart;

	constructor(
		private router: Router,
	) { }

	processRemoveTickets(ticketItemUuidsToBeRemoved: string[]) {
		this.removeTickets.emit(ticketItemUuidsToBeRemoved)
	}

	navigateToEventSale(eventId: number) {
		const eventWithCtrl: DisplayEventWithTicketControls = this.displayEventsWithTicketControls
			.filter(displayEventWithTktCtrl => displayEventWithTktCtrl.eventId === eventId)[0]

		const saleType = (eventWithCtrl.visualTickets || eventWithCtrl.visualBulkTickets) ? "seatingplanSale" : "sale"
		this.router.navigate(["/" + saleType, eventId]);
	}
}

export interface DisplayEventWithTicketControls {
	eventId: number;
	event: string
	eventBegin: string
	eventEnd: string
	venue: string
	locationPostalCode: string
	locationCity: string
	visualTickets: boolean
	visualBulkTickets: boolean

	displayTicketsWithControls: DisplayTicketWithControl[]
}

export interface DisplayTicketWithControl {
	displayTicket: model.DisplayTicket
	control: FormControl
}



// WEBPACK FOOTER //
// ./src/app/components/shopping-cart/shopping-cart-event-list/shopping-cart-event-list.component.ts